import { ProfilePic } from "../../pissarra/watchers/UserList";

function Ranking({ ranking, nHores, displayName }) {
    const hasRanking = Object.keys(ranking).length > 0;

    return (
        <div
            style={{
                marginTop: 100,
                paddingBottom: 15,
            }}
        >
            <h2>Membres més actius les últimes {nHores} hores</h2>

            {hasRanking ? (
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                {
                    Object.entries(ranking)
                        .sort(([,a],[,b]) => b-a)
                        .map(([author, count], index) => (
                            <div key={index} style={{
                                display: 'flex',
                                flexDirection: 'column',
                                margin: 15,
                                gap: 20,
                            }}>
                                <ProfilePic
                                    user={author}
                                    width={50}
                                    height={50}
                                    rounded={false}
                                    touchToEnlarge={true}
                                />
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontWeight: 'bold', marginBottom: '5px' }}>{displayName(author)}</span>
                                    <span>{count} canvis</span>
                                </div>
                            </div>
                        ))
                }
                </div>
            ) : (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px',
                    color: '#6b7280',
                    fontSize: '16px',
                    fontStyle: 'italic',
                    backgroundColor: '#f9fafb',
                    borderRadius: '8px',
                    border: '1px dashed #d1d5db',
                }}>
                    Cap canvi en les últimes {nHores} hores
                </div>
            )}

        </div>
    )
}

export default Ranking;